import { DimensionType } from './field';
import { FilterOperator } from './filter';
/**
 * Operators the Metrics Explorer filter UI can render (see getOperatorOptions).
 * The compile-time validation of a metric's spotlight `default_filter` and the
 * explorer's operator dropdown both read from this single list.
 */
export const METRICS_EXPLORER_FILTER_OPERATORS = [
    FilterOperator.EQUALS,
    FilterOperator.NOT_EQUALS,
];
/**
 * A dimension whose type can be used to segment or filter in the Metrics
 * Explorer: a string or boolean that is not a time-derived dimension.
 */
export const isMetricsExplorerCompatibleDimension = (dimension) => !dimension.timeIntervalBaseDimensionName &&
    (dimension.type === DimensionType.STRING ||
        dimension.type === DimensionType.BOOLEAN);
export var MetricExplorerComparison;
(function (MetricExplorerComparison) {
    MetricExplorerComparison["NONE"] = "none";
    MetricExplorerComparison["PREVIOUS_PERIOD"] = "previous_period";
    MetricExplorerComparison["DIFFERENT_METRIC"] = "different_metric";
})(MetricExplorerComparison || (MetricExplorerComparison = {}));
export var MetricTotalComparisonType;
(function (MetricTotalComparisonType) {
    MetricTotalComparisonType["NONE"] = "none";
    MetricTotalComparisonType["PREVIOUS_PERIOD"] = "previous_period";
    MetricTotalComparisonType["ROLLING_DAYS"] = "rolling_days";
})(MetricTotalComparisonType || (MetricTotalComparisonType = {}));
//# sourceMappingURL=metricsExplorer.js.map